import { useState } from 'react';
import { categoryStyle, resolveImage } from '../../lib/summaries';

const LEAVES_D = [28, 52, 76, 100, 124, 148, 172].map((y, i) => {
  const s = i % 2 === 0 ? -1 : 1;
  const x = 60;
  return `M${x} ${y} C${x + s * 8} ${y - 14} ${x + s * 26} ${y - 18} ${x + s * 36} ${y - 14} C${x + s * 28} ${y - 2} ${x + s * 12} ${y + 4} ${x} ${y} Z`;
}).join(' ');

export const OliveBranch = ({ className = '' }) => (
  <svg viewBox="0 0 120 200" className={className} fill="currentColor" aria-hidden="true">
    <path d="M60 196 C56 150 64 100 58 8" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d={LEAVES_D} />
    <circle cx="70" cy="62" r="5" />
    <circle cx="48" cy="136" r="5" />
  </svg>
);

const TypographicCover = ({ title, author, category, large }) => {
  const [from, to] = categoryStyle(category).cover;
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4 py-6 overflow-hidden"
      style={{ background: `linear-gradient(160deg, ${from}, ${to})` }}>
      <OliveBranch className="absolute -left-4 bottom-2 h-2/3 text-white/20 rotate-12" />
      <div className="absolute top-4 inset-x-6 h-px bg-white/30" />
      <div className="absolute bottom-4 inset-x-6 h-px bg-white/30" />
      <h4 className={`relative font-bold leading-snug line-clamp-4 break-words ${large ? 'text-3xl' : 'text-base md:text-lg'}`}>{title || 'بلا عنوان'}</h4>
      {author && <p className={`relative mt-3 text-white/80 line-clamp-2 ${large ? 'text-base' : 'text-[11px]'}`}>{author}</p>}
    </div>
  );
};

export const BookCover = ({ item, large = false }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const src = resolveImage(item.image_url);
  const showImage = src && !failed;
  return (
    <div className="relative aspect-[2/3] w-full overflow-hidden rounded-r-md rounded-l-sm bg-[#E8E0D5] shadow-[0_10px_20px_-12px_rgba(93,64,55,0.55)]">
      {showImage ? (
        <>
          {!loaded && <div className="absolute inset-0 bg-gradient-to-br from-[#E8E0D5] to-[#d8cbb9] animate-pulse" />}
          <img src={src} alt={`غلاف ${item.title}`} loading="lazy" decoding="async"
            onLoad={() => setLoaded(true)} onError={() => setFailed(true)}
            className={`absolute inset-0 w-full h-full object-cover transition-[opacity,filter,transform] duration-300 group-hover:scale-[1.03] ${loaded ? 'opacity-100 blur-0' : 'opacity-0 blur-md'}`} />
        </>
      ) : (
        <TypographicCover title={item.title} author={item.author} category={item.category} large={large} />
      )}
      <div className="absolute inset-y-0 right-0 w-3 bg-gradient-to-l from-black/30 via-black/10 to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-3 w-px bg-white/25 pointer-events-none" />
    </div>
  );
};
